function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 10.04,
  d: "M3.9 30.85l19.73 19.39L60.1 13.76"
});

function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "checkmark",
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9ImNoZWNrbWFyayIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNjQgNjQiPgogIDxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMTAuMDQiIGQ9Ik0zLjkgMzAuODVsMTkuNzMgMTkuMzlMNjAuMSAxMy43NiIvPgo8L3N2Zz4=";
export { SvgCheckmark as ReactComponent };